var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalScans(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60801 24.984C3.528 22.896 2.88 20.52 2.88 18C2.88 9.648 9.648 2.88 18 2.88C20.592 2.88 22.968 3.528 25.128 4.60801",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.888 10.08C32.328 12.384 33.12 15.048 33.12 18C33.12 26.352 26.352 33.12 18 33.12C15.12 33.12 12.384 32.328 10.08 30.888",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.48C21.5788 24.48 24.48 21.5788 24.48 18C24.48 14.4212 21.5788 11.52 18 11.52C14.4212 11.52 11.52 14.4212 11.52 18C11.52 21.5788 14.4212 24.48 18 24.48Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V36",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18H0",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.44 10.8C30.6271 10.8 32.4 9.02705 32.4 6.84C32.4 4.65296 30.6271 2.88 28.44 2.88C26.253 2.88 24.48 4.65296 24.48 6.84C24.48 9.02705 26.253 10.8 28.44 10.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 32.4C9.02705 32.4 10.8 30.627 10.8 28.44C10.8 26.2529 9.02705 24.48 6.84 24.48C4.65296 24.48 2.88 26.2529 2.88 28.44C2.88 30.627 4.65296 32.4 6.84 32.4Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalScans);
export default __webpack_public_path__ + "static/media/totalScans.95435afb964ab062b6811e2192ba74db.svg";
export { ForwardRef as ReactComponent };